// Copyright © 2021 Move Closer
import { computed } from '@vue/composition-api';
/**
 * Props partial.
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const hasErrorsProp = {
    errors: {
        type: Array,
        required: false,
        default: () => []
    }
};
/**
 * @param errors - Component's `errors` reactive reference.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const useHasErrors = (errors) => {
    /**
     * Determines whether the control has any validation errors.
     */
    return computed(() => Array.isArray(errors.value) && errors.value.length > 0);
};
